import { render } from "./BuletinView.vue?vue&type=template&id=1d124ce0"
import script from "./BuletinView.vue?vue&type=script&lang=js"
export * from "./BuletinView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__